/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sig_type_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type Signature Generator — Signature from Name | Toolverse`)
};

const es_sig_type_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generador de Firmas Escrito — Firma a partir del Nombre | Toolverse`)
};

const de_sig_type_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signaturgenerator — Signatur aus Name | Toolverse`)
};

const nl_sig_type_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Handtekeninggenerator voor typen — Handtekening van naam | Toolverse`)
};

const fr_sig_type_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Générateur de Signature Dactylographiée — Signature du Nom | Toolverse`)
};

const it_sig_type_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generatore di Firme Digitate — Firma da Nome | Toolverse`)
};

const pt_br2_sig_type_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador de Assinatura Digitada — Assinatura a partir do Nome | Toolverse`)
};

const pt_sig_type_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador de Assinatura Digitada — Assinatura a partir de Nome | Toolverse`)
};

const ja_sig_type_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`署名ジェネレータを入力 — 名前から署名 | Toolverse`)
};

const zh_sig_type_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入签名生成器 — 从名字生成签名 | Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sig_type_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sig_type_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sig_type_meta_title", locale)
	if (locale === "en") return en_sig_type_meta_title(inputs)
	if (locale === "es") return es_sig_type_meta_title(inputs)
	if (locale === "de") return de_sig_type_meta_title(inputs)
	if (locale === "nl") return nl_sig_type_meta_title(inputs)
	if (locale === "fr") return fr_sig_type_meta_title(inputs)
	if (locale === "it") return it_sig_type_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_sig_type_meta_title(inputs)
	if (locale === "pt") return pt_sig_type_meta_title(inputs)
	if (locale === "ja") return ja_sig_type_meta_title(inputs)
	return zh_sig_type_meta_title(inputs)
};